import { useContext, useEffect, useState } from 'react';
import { Card, CardBody, Col, Form, Input, Label, Row } from 'reactstrap';
import { DateFormateChange, isEmpty, maxLengthCheck, toCamelCase } from '../../utils/helper';
import './AccommodationForm.css';
import { toast, Zoom, ToastContainer } from 'react-toastify';
import PublicPageContext from '../../context/PublicPageContext/PublicPageContext';
import {
  booking_verify_payment,
  booking_verify_payment_failed,
  CreatePersoneMaster_Public,
  Donation_bill_Details_personId_Public,
  templeTrust_detail,
  UpdatePersoneMaster_Step_Two_Public
} from '../../api/DonationBillApi/DonationCillapi';
import { useNavigate, useParams } from 'react-router';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { DialCodeList } from '../../api/DialCodeApi/DialCodeApi';
import { Plus } from 'react-feather';
import { Get_Booking_Invite_Detail_Public } from '../../api/AccommodationApi/AccommodationApi';
import PublicHeaderComponent from '../../common/PublicHeaderComponent';
import Loader2 from '../../loader/Loader2';

function loadRazorpayScript(src = 'https://checkout.razorpay.com/v1/checkout.js') {
  return new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve(true);
    const script = document.createElement('script');
    script.src = src;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
}
const initialState = Object.freeze({
  personId: '',
  noOfPerson: 0,
  checkInDateTime: null,
  checkOutDateTime: null,
  occupation: '',
  refName: '',
  refMobileNo: '',
  trustUuid: '',
  persons: [
    {
      name: '',
      dialCode: '+91',
      contactNo: '',
      dob: '',
      gender: ''
    }
  ]
});

const AccommodationFormStepTwo = () => {
  const { dialCode } = useContext(PublicPageContext);
  const [formData, setFormData] = useState(initialState);
  const [token, setToken] = useState('');
  const [per_person_charge, setPer_person_charge] = useState(0);
  const history = useNavigate();
  const [isLoading, setisLoading] = useState(false);
  const [click, setClick] = useState(false);
  const { orgId: routeOrgId, templeUuid: routeTempleUuid, trustUuid: routeTrustUuid, personId, inviteToken } = useParams();
  const [inviteData, setInviteData] = useState(null);
  const [inviteError, setInviteError] = useState(
    !inviteToken
      ? 'Direct booking via this link has been deactivated. Accommodation bookings now strictly require a valid private invitation link generated by temple administration. Please contact the temple desk to receive an active link.'
      : null
  );
  const [isInviteLoading, setIsInviteLoading] = useState(Boolean(inviteToken));

  const orgId = inviteData?.orgId || routeOrgId;
  const templeUuid = inviteData?.templeUuid || routeTempleUuid;
  const trustUuid = inviteData?.trustUuid || routeTrustUuid;

  const [dialCodeJson, setDialCodeJson] = useState([]);
  const [totalPayble, settotalPayble] = useState(0);
  const [templeDetail, setTempleDetail] = useState({});
  const [razorpayOrder, setRazorpayOrder] = useState(null);
  const [errors, setErrors] = useState({
    checkOutDateTime: ''
  });

  useEffect(() => {
    if (!inviteToken) {
      setInviteError(
        'Direct booking via this link has been deactivated. Accommodation bookings now strictly require a valid private invitation link generated by temple administration. Please contact the temple desk to receive an active link.'
      );
      setIsInviteLoading(false);
      return;
    }

    const fetchInvite = async () => {
      setIsInviteLoading(true);
      try {
        const { data } = await Get_Booking_Invite_Detail_Public(inviteToken);
        if (data?.status === 200) {
          const payload = data.payload;
          if (!payload?.isUsable) {
            setInviteError(
              payload?.status === 'used'
                ? 'This booking link has already been used. Each link is for one-time booking only. Please contact the administrator for a new booking link.'
                : 'This booking link has expired (links are valid for 48 hours). Please contact the administrator for a new booking link.'
            );
          } else {
            setInviteData(payload);
            const inDate = new Date(payload.checkInDateTime);
            const outDate = new Date(payload.checkOutDateTime);
            setFormData((prev) => ({
              ...prev,
              checkInDateTime: inDate,
              checkOutDateTime: outDate,
              trustUuid: payload.trustUuid || prev.trustUuid
            }));

            if (personId && payload.orgId) {
              showHandle({ personId, targetOrgId: payload.orgId });
            }
          }
        } else {
          setInviteError(data?.message || 'Invalid booking link');
        }
      } catch (error) {
        setInviteError(error?.response?.data?.message || 'Invalid or expired booking link');
      } finally {
        setIsInviteLoading(false);
      }
    };
    fetchInvite();
  }, [inviteToken, personId]);

  const showHandle = async ({ personId, targetOrgId }) => {
    try {
      const currentOrgId = targetOrgId || orgId;
      if (!currentOrgId || !personId) return;

      const { data } = await Donation_bill_Details_personId_Public(personId, currentOrgId);
      if (data.status === 200) {
        let payload = data.payload.data;

        if (payload !== null && payload !== undefined) {
          const dialCode = payload.mobile ? payload.mobile.split(' ')[0] : '+91';
          const contactNo = payload.mobile ? payload.mobile.split(' ')[1] || payload.mobile : '';
          setFormData((prev) => ({
            ...prev,
            personId: payload.personId ? payload.personId : '',
            trustUuid: trustUuid || prev.trustUuid,
            personToken: data?.payload?.personToken,
            persons: [
              {
                name: payload.name ? payload.name : '',
                dialCode: dialCode ? dialCode : '+91',
                contactNo: contactNo ? contactNo : '',
                dob: payload.dob ? new Date(DateFormateChange(payload.dob)) : '',
                gender: payload.gender ? payload.gender : ''
              }
            ]
          }));
          setToken(data?.payload?.personToken);
          const charge = data?.payload?.per_person_charge || 0;
          setPer_person_charge(charge);
          calculateTotalPayable({
            person: 1,
            charge
          });
        } else {
          return true;
        }
      }
    } catch (error) {
      toast.error(error.response, {
        autoClose: 1000,
        transition: Zoom
      });
    }
  };

  const calculateTotalPayable = ({
    person,
    checkInDateTime = '',
    checkOutDateTime = '',
    charge
  } = {}) => {
    const totalPersons = person !== undefined ? person : (formData.persons?.length || 1);
    const rate = charge !== undefined ? charge : per_person_charge;

    const checkIn = moment(checkInDateTime || formData.checkInDateTime);
    const checkOut = moment(checkOutDateTime || formData.checkOutDateTime);

    if (!checkIn.isValid() || !checkOut.isValid()) {
      return 0;
    }

    // Correct difference (checkOut - checkIn)
    let stayDays = Math.ceil(checkOut.diff(checkIn, 'days', true));

    // If stayDays is 0 → count as 1 day
    if (stayDays <= 0) stayDays = 1;

    const totalAmount = totalPersons * (rate || 0) * stayDays;
    settotalPayble(totalAmount);
    return totalAmount;
  };

  useEffect(() => {
    if (!inviteToken && personId && orgId) {
      showHandle({ personId, targetOrgId: orgId });
    }
  }, [inviteToken, personId, orgId]);

  useEffect(() => {
    if (formData.checkInDateTime && formData.checkOutDateTime && per_person_charge > 0) {
      calculateTotalPayable({
        person: formData.persons.length,
        checkInDateTime: formData.checkInDateTime,
        checkOutDateTime: formData.checkOutDateTime,
        charge: per_person_charge
      });
    }
  }, [formData.persons.length, formData.checkInDateTime, formData.checkOutDateTime, per_person_charge]);

  useEffect(() => {
    setDialCodeJson(DialCodeList());
  }, []);

  const emptyUserDetails = () => {
    const { contactNo, dialCode, ...rest } = initialState;
    setFormData((prev) => ({
      ...prev,
      ...rest
    }));
  };

  const handleChangeDialCode = async (value) => {
    const contact = formData?.contactNo;
    if (value && contact?.length === 10) {
      const isEmpty = await showHandle(`${value} ${contact}`);
      if (isEmpty && typeof isEmpty === 'boolean') {
        emptyUserDetails();
      }
    }
  };

  const emplyFeild = () => {
    setFormData(initialState);
    setRazorpayOrder(null);
  };

  const openRazorpay = async (razorpayOrder) => {
    try {
      const ok = await loadRazorpayScript();
      if (!ok) {
        return alert('Razorpay SDK failed to load. Check your connection.');
      }

      const options = {
        key: razorpayOrder?.key, // public key from server response
        amount: razorpayOrder?.amount, // in paise
        currency: razorpayOrder?.currency,
        name: templeDetail?.templeName || 'Your Company / App',
        description: templeDetail?.address || 'Payment description',
        order_id: razorpayOrder?.orderId,
        prefill: {
          name: razorpayOrder?.prefillData?.name,
          contact: razorpayOrder?.prefillData?.contactNo
        },
        notes: {
          // optional
          customer_name: razorpayOrder?.prefillData?.name,
          customer_number: razorpayOrder?.prefillData?.contactNo
        },
        handler: async function (response) {
          try {
            const verifyResp = await booking_verify_payment({
              personToken: formData.personToken,
              razorpay_order_id: response.razorpay_order_id,
              razorpay_payment_id: response.razorpay_payment_id,
              razorpay_signature: response.razorpay_signature,
              trustUuid: formData.trustUuid,
              inviteToken: inviteToken || undefined
            });

            if (verifyResp.data?.status === 200 && verifyResp.data.message) {
              emplyFeild();
              history(
                `/accommodation/Thankyou/${orgId}/${templeUuid}/${trustUuid}/${verifyResp.data.payload?.razorpay_order_id}`
              );
            } else {
              alert('Payment verification failed on server.');
            }
          } catch (err) {
            console.error('verify error', err?.response?.data || err.message);
            alert('Server verification failed. Check console.');
          }
        },
        modal: {
          ondismiss: async function () {
            console.log('Checkout closed');
            try {
              const errorObj = {
                error: {
                  description: 'Checkout closed'
                }
              };
              const failedVerifyResp = await booking_verify_payment_failed({
                personToken: formData.personToken,
                razorpay_order_id: razorpayOrder?.orderId,
                trustUuid: formData.trustUuid,
                error: JSON.stringify(errorObj)
              });

              if (failedVerifyResp.data?.status === 200 && failedVerifyResp.data.message) {
                console.log('failedVerifyResp CALL');
              } else {
                alert('FAILED Payment verification failed on server.');
              }
            } catch (err) {
              console.error('verify error', err?.response?.data || err.message);
              alert('Server verification failed. Check console.');
            }
          }
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', async function (response) {
        try {
          // 4) Send response to server to verify signature
          const failedVerifyResp = await booking_verify_payment_failed({
            personToken: formData.personToken,
            razorpay_order_id: response?.error?.metadata?.order_id,
            razorpay_payment_id: response?.error?.metadata?.payment_id,
            trustUuid: formData.trustUuid,
            error: JSON.stringify(response)
          });

          if (failedVerifyResp.data?.status === 200 && failedVerifyResp.data.message) {
            console.log('failedVerifyResp CALL');
          } else {
            alert('FAILED Payment verification failed on server.');
          }
        } catch (err) {
          console.error('verify error', err?.response?.data || err.message);
          alert('Server verification failed. Check console.');
        }
        toast.error(response.error?.description || 'Payment failed. Please try again.', {
          autoClose: 2000,
          transition: Zoom
        });
        setClick(false);
      });
      rzp.open();
    } catch (error) {
      console.log('RAZ ERROR : >> ', error);
    }
  };

  const hasInvalidDuplicateNumbers = () => {
    const countMap = {};

    for (const person of formData.persons) {
      if (!person.contactNo) continue;

      countMap[person.contactNo] = (countMap[person.contactNo] || 0) + 1;

      // ❌ more than 2 times
      if (countMap[person.contactNo] > 2) {
        return true;
      }
    }

    return false;
  };

  const onSubmit = async (e) => {
    setisLoading(true);
    e.preventDefault();
    try {
      if (inviteData?.maxGuests && formData.persons.length > inviteData.maxGuests) {
        toast.error(`Maximum of ${inviteData.maxGuests} guest(s) allowed for this booking invitation.`, {
          autoClose: 3000,
          transition: Zoom
        });
        setisLoading(false);
        return;
      }
      if (hasInvalidDuplicateNumbers()) {
        alert('Same mobile number is allowed only 2 times');
        return; // ❌ stop submit
      }
      let newFormData = isEmpty({
        ...formData,
        // checkInDateTime: moment(formData.checkInDateTime).format('yyyy-MM-DD'),
        checkInDateTime: moment(formData.checkInDateTime).format('YYYY-MM-DDTHH:mm'),
        checkOutDateTime: moment(formData.checkOutDateTime).format('YYYY-MM-DDTHH:mm'),
        inviteToken: inviteToken || undefined
      });
      newFormData['persons'] = formData.persons.map((elem) => {
        return { ...elem, dob: elem?.dob ? moment(elem?.dob).format('yyyy-MM-DD') : null };
      });
      if (formData?.personId) {
        const { data } = await UpdatePersoneMaster_Step_Two_Public(newFormData, token);
        if (data.status === 200) {
          const { orderId, amount: orderAmount, currency, key } = data.payload;
          const myObj = {
            orderId,
            amount: orderAmount,
            currency,
            key,
            prefillData: newFormData.persons[0]
          };
          setRazorpayOrder(myObj);
          openRazorpay(myObj);
          setClick(false);
        } else {
        }
      } else {
        const { data } = await CreatePersoneMaster_Public(newFormData);
        if (data.status === 200) {
          toast.success(data.message, {
            autoClose: 1000,
            transition: Zoom
          });
          setToken(data?.payload?.personToken);
          emplyFeild();
          if (inviteToken) {
            history(`/accommodation/invite/${inviteToken}/${data?.payload?.personId || formData?.personId}`);
          }
          setClick(false);
        } else {
        }
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        autoClose: 1000,
        transition: Zoom
      });
    } finally {
      setisLoading(false);
    }
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    const fields = ['name', 'city', 'state', 'country'];
    setFormData((prev) => ({ ...prev, [name]: fields.includes(name) ? toCamelCase(value) : value }));
    if (['dialCode', 'contactNo'].includes(name)) {
      if (name === 'dialCode') {
        handleChangeDialCode(value);
      } else if (value.length === 10 && name === 'contactNo') {
        const isEmpty = await showHandle({ mobileNumber: `${dialCode} ${value}`, value });
        if (isEmpty) {
          emptyUserDetails();
        }
      } else if (name === 'contactNo' && value.length < 10) {
        emptyUserDetails();
      }
    }
  };
  const removePerson = (index) => {
    setFormData((prev) => ({
      ...prev,
      persons: prev.persons.filter((_, i) => i !== index)
    }));
    calculateTotalPayable({ person: formData.persons.length - 1 });
  };

  const handlePersonChange = (index, e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updated = [...prev.persons];
      updated[index][name] = value;
      return { ...prev, persons: updated };
    });
  };

  const addPersonToList = () => {
    if (inviteData?.maxGuests && formData.persons.length >= inviteData.maxGuests) {
      toast.warning(
        `Maximum limit of ${inviteData.maxGuests} guest(s) reached for this booking invitation.`,
        { autoClose: 3000, transition: Zoom }
      );
      return;
    }
    setFormData((prev) => ({
      ...prev,
      persons: [
        ...prev.persons,
        {
          name: '',
          dialCode: '+91',
          contactNo: '',
          dob: '',
          gender: ''
        }
      ]
    }));
    calculateTotalPayable({ person: formData.persons.length + 1 });
  };

  useEffect(() => {
    const fetchTemple = async () => {
      try {
        if (!templeUuid) return;
        const { data } = await templeTrust_detail(templeUuid);
        if (data.status === 200) {
          setTempleDetail({
            ...data.payload.data
          });
        }
      } catch (error) {
        console.log('error >> ', error);
      }
    };
    fetchTemple();
  }, [templeUuid]);

  return (
    <div className="panel">
      <ToastContainer />
      {(click === true || isLoading || isInviteLoading) && <Loader2 />}
      <div className="donarbackGround">
        {/* <div className="contentStyles"> */}
        <PublicHeaderComponent secondTitle="blue" therdTitle="black" templeUuid={templeUuid} />
        <Col
          sm="12"
          className="donarcontainer"
          style={{
            paddingTop: '0.5rem',
            paddingBottom: '4rem',
            paddingRight: '1rem',
            paddingLeft: '1rem'
          }}
        >
          {inviteError ? (
            <Card className="doanrbackgroundcolor text-center p-4 shadow-sm my-4">
              <CardBody className="py-5">
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
                <h4 className="text-danger mb-3 fw-bold">Booking Link Unavailable</h4>
                <p className="text-muted mb-4" style={{ fontSize: '15px', maxWidth: '580px', margin: '0 auto', lineHeight: '1.6' }}>
                  {inviteError}
                </p>
                <div className="mt-2">
                  <span className="badge bg-secondary p-2" style={{ fontSize: '13px' }}>
                    Single-Use Secure Link Policy
                  </span>
                </div>
              </CardBody>
            </Card>
          ) : (
            <Card className="doanrbackgroundcolor accommodation-card">
              <CardBody className="p-4">
              {inviteData && (
                <div className="reservation-banner-wrapper">
                  <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
                    <div className="d-flex align-items-center gap-2">
                      <span style={{ fontSize: '18px' }}>🔒</span>
                      <div>
                        <div className="fw-bold text-dark" style={{ fontSize: '15px' }}>
                          Pre-Approved Guest Reservation
                        </div>
                        {inviteData.guestName && (
                          <small className="text-muted">
                            Guest: <strong className="text-dark">{inviteData.guestName}</strong> • Step 2: Final Details & Booking
                          </small>
                        )}
                      </div>
                    </div>
                    <span className="badge bg-primary px-3 py-2" style={{ fontSize: '12px', borderRadius: '20px' }}>
                      Single-Use Secure Link
                    </span>
                  </div>

                  <div className="reservation-dates-row">
                    <div className="date-pill-box">
                      <span className="date-pill-label">🗓️ Reserved Check-In</span>
                      <span className="date-pill-value">
                        {moment(inviteData.checkInDateTime).format('DD MMM YYYY, hh:mm A')}
                      </span>
                    </div>

                    <span className="date-connector-icon">➔</span>

                    <div className="date-pill-box">
                      <span className="date-pill-label">🗓️ Reserved Check-Out</span>
                      <span className="date-pill-value">
                        {moment(inviteData.checkOutDateTime).format('DD MMM YYYY, hh:mm A')}
                      </span>
                    </div>

                    {inviteData.maxGuests && (
                      <>
                        <span className="date-connector-icon">•</span>
                        <div className="date-pill-box">
                          <span className="date-pill-label">👥 Max Allowed Guests</span>
                          <span className="date-pill-value">
                            {inviteData.maxGuests} {inviteData.maxGuests === 1 ? 'Person' : 'Persons'}
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )}
              <Row>
                <Col sm="12">
                  <Form className="needs-validation" onSubmit={(e) => onSubmit(e)}>
                    {/* Stay & Reference Information */}
                    <Row>
                      {!inviteToken ? (
                        <>
                          <Col md="3" sm="6" className="mb-3">
                            <Label className="form-label-custom" htmlFor="checkIn">{'Check In Time (प्रवेश समय)*'}</Label>
                            <input
                              type="datetime-local"
                              id="checkIn"
                              className="form-control colorBlack form-control-custom"
                              min={moment().format('YYYY-MM-DDTHH:mm')}
                              value={
                                formData?.checkInDateTime ? moment(formData.checkInDateTime).format('YYYY-MM-DDTHH:mm') : ''
                              }
                              onChange={(e) => {
                                const date = new Date(e.target.value);
                                setFormData((prev) => {
                                  const updated = { ...prev, checkInDateTime: date };
                                  if (prev.checkOutDateTime && prev.checkOutDateTime < date) {
                                    updated.checkOutDateTime = null;
                                    setErrors((err) => ({
                                      ...err,
                                      checkOutDateTime: 'Check-out must be after check-in'
                                    }));
                                  }
                                  return updated;
                                });
                                calculateTotalPayable({
                                  person: formData.persons.length,
                                  checkInDateTime: date
                                });
                              }}
                              required
                            />
                          </Col>

                          <Col md="3" sm="6" className="mb-3">
                            <Label className="form-label-custom" htmlFor="checkOut">{'Check Out Time (प्रस्थान समय)*'}</Label>
                            <input
                              type="datetime-local"
                              id="checkOut"
                              className="form-control colorBlack form-control-custom"
                              min={
                                formData?.checkInDateTime
                                  ? moment(formData.checkInDateTime).format('YYYY-MM-DDTHH:mm')
                                  : moment().format('YYYY-MM-DDTHH:mm')
                              }
                              value={
                                formData?.checkOutDateTime
                                  ? moment(formData.checkOutDateTime).format('YYYY-MM-DDTHH:mm')
                                  : ''
                              }
                              onChange={(e) => {
                                const date = new Date(e.target.value);
                                if (formData.checkInDateTime && date < formData.checkInDateTime) {
                                  setErrors((prev) => ({
                                    ...prev,
                                    checkOutDateTime: 'Check-out time cannot be earlier than check-in time'
                                  }));
                                  return;
                                }
                                setErrors((prev) => ({ ...prev, checkOutDateTime: '' }));
                                setFormData((prev) => ({ ...prev, checkOutDateTime: date }));
                                calculateTotalPayable({
                                  person: formData.persons.length,
                                  checkOutDateTime: date
                                });
                              }}
                              required
                            />
                            {errors.checkOutDateTime && (
                              <div style={{ color: 'red', fontSize: '13px' }} className="invalid-feedback d-block">
                                {errors.checkOutDateTime}
                              </div>
                            )}
                          </Col>

                          <Col md="2" sm="6" className="mb-3">
                            <Label className="form-label-custom" htmlFor="occupation">{'Occupation (व्यवसाय)*'}</Label>
                            <Input
                              className="form-control colorBlack form-control-custom"
                              name="occupation"
                              type="text"
                              id="occupation"
                              placeholder={'Occupation'}
                              value={formData.occupation}
                              onChange={(e) => handleChange(e)}
                              required
                            />
                          </Col>

                          <Col md="2" sm="6" className="mb-3">
                            <Label className="form-label-custom" htmlFor="refName">{'Reference Name (संदर्भ नाम)*'}</Label>
                            <Input
                              className="form-control colorBlack form-control-custom"
                              name="refName"
                              type="text"
                              id="refName"
                              placeholder={'Reference Name'}
                              value={formData.refName}
                              onChange={(e) => handleChange(e)}
                              required
                            />
                          </Col>

                          <Col md="2" sm="6" className="mb-3">
                            <Label className="form-label-custom" htmlFor="refMobileNo">{'Reference Number (संदर्भ नंबर)'}</Label>
                            <Input
                              className="form-control colorBlack form-control-custom"
                              name="refMobileNo"
                              type="number"
                              id="refMobileNo"
                              placeholder={'Reference Number'}
                              value={formData.refMobileNo}
                              onChange={(e) => handleChange(e)}
                              min={0}
                              maxLength={10}
                              onInput={maxLengthCheck}
                            />
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col md="4" sm="6" className="mb-3">
                            <Label className="form-label-custom" htmlFor="occupation">{'Occupation (व्यवसाय)*'}</Label>
                            <Input
                              className="form-control colorBlack form-control-custom"
                              name="occupation"
                              type="text"
                              id="occupation"
                              placeholder={'e.g. Business, Engineer, Service'}
                              value={formData.occupation}
                              onChange={(e) => handleChange(e)}
                              required
                            />
                          </Col>

                          <Col md="4" sm="6" className="mb-3">
                            <Label className="form-label-custom" htmlFor="refName">{'Reference Name (संदर्भ नाम)*'}</Label>
                            <Input
                              className="form-control colorBlack form-control-custom"
                              name="refName"
                              type="text"
                              id="refName"
                              placeholder={'Reference Person Name'}
                              value={formData.refName}
                              onChange={(e) => handleChange(e)}
                              required
                            />
                          </Col>

                          <Col md="4" sm="6" className="mb-3">
                            <Label className="form-label-custom" htmlFor="refMobileNo">{'Reference Number (संदर्भ नंबर)'}</Label>
                            <Input
                              className="form-control colorBlack form-control-custom"
                              name="refMobileNo"
                              type="number"
                              id="refMobileNo"
                              placeholder={'10-digit mobile number'}
                              value={formData.refMobileNo}
                              onChange={(e) => handleChange(e)}
                              min={0}
                              maxLength={10}
                              onInput={maxLengthCheck}
                            />
                          </Col>
                        </>
                      )}
                    </Row>

                    {/* Guest / Co-Traveller List */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3 mt-3 pt-2">
                      <h5 className="fw-bold mb-0 text-dark" style={{ fontSize: '15px' }}>
                        👥 Guests & Co-Travellers
                      </h5>
                      <span className="badge bg-light text-muted border px-2 py-1" style={{ fontSize: '12px' }}>
                        Total: <strong>{formData.persons.length}</strong> Guest{formData.persons.length > 1 ? 's' : ''}
                      </span>
                    </div>

                    <Row>
                      {formData.persons.map((person, index) => (
                        <div key={index} className="col-12 mb-3">
                          <div className="person-box">
                            <div className="person-box-header">
                              <span className="person-box-title">
                                {index === 0 ? '👤 Guest #1 (Primary Guest)' : `👤 Guest #${index + 1}`}
                              </span>
                              {formData.persons.length > 1 && index !== 0 && (
                                <button
                                  className="btn btn-outline-danger btn-sm py-1 px-3 d-inline-flex align-items-center gap-1"
                                  onClick={() => removePerson(index)}
                                  type="button"
                                  style={{ borderRadius: '6px' }}
                                >
                                  Remove
                                </button>
                              )}
                            </div>

                            <Row>
                              {/* Contact */}
                              <Col md="3" sm="6" className="mb-2">
                                <Label className="form-label-custom">{'Contact No. (संपर्क नंबर)*'}</Label>
                                <div className="d-flex">
                                  <select
                                    className="form-control colorBlack dial-code-select-custom"
                                    name="dialCode"
                                    value={person.dialCode}
                                    onChange={(e) => handlePersonChange(index, e)}
                                    disabled={index === 0}
                                  >
                                    {dialCodeJson.map((elem, i) => (
                                      <option key={i} value={elem.code}>
                                        {elem.country}
                                      </option>
                                    ))}
                                  </select>
                                  <Input
                                    className="form-control colorBlack form-control-custom contact-input-custom"
                                    name="contactNo"
                                    type="number"
                                    placeholder="Contact"
                                    min={0}
                                    maxLength={10}
                                    onInput={maxLengthCheck}
                                    onWheel={(e) => e.target.blur()}
                                    value={person.contactNo}
                                    onChange={(e) => handlePersonChange(index, e)}
                                    required
                                    disabled={index === 0}
                                  />
                                </div>
                              </Col>

                              {/* Name */}
                              <Col md="3" sm="6" className="mb-2">
                                <Label className="form-label-custom">{'Name (नाम)*'}</Label>
                                <Input
                                  className="form-control colorBlack form-control-custom"
                                  name="name"
                                  type="text"
                                  placeholder="Person Name"
                                  value={person.name}
                                  onChange={(e) => handlePersonChange(index, e)}
                                  required
                                  disabled={index === 0}
                                />
                              </Col>

                              {/* DOB */}
                              <Col md="3" sm="6" className="mb-2">
                                <Label className="form-label-custom">{'Birthdate (जन्म तिथि)*'}</Label>
                                <input
                                  className="form-control colorBlack form-control-custom"
                                  name="dob"
                                  type="date"
                                  value={person.dob ? moment(person.dob).format('YYYY-MM-DD') : ''}
                                  onChange={(e) => handlePersonChange(index, e)}
                                  required
                                  disabled={index === 0}
                                />
                              </Col>

                              {/* Gender */}
                              <Col md="3" sm="6" className="mb-2">
                                <Label className="form-label-custom">{'Gender (लिंग)*'}</Label>
                                <select
                                  className="form-control colorBlack form-control-custom"
                                  name="gender"
                                  value={person.gender}
                                  onChange={(e) => handlePersonChange(index, e)}
                                  required
                                  disabled={index === 0}
                                >
                                  <option value="">-- select --</option>
                                  <option value="male">Male</option>
                                  <option value="female">Female</option>
                                </select>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      ))}

                      {/* Add Person Button */}
                      <Col xs="12" className="mt-1 mb-2">
                        {inviteData?.maxGuests && formData.persons.length >= inviteData.maxGuests ? (
                          <div
                            className="p-2 text-center rounded"
                            style={{
                              background: '#fef3c7',
                              border: '1px solid #fde68a',
                              color: '#92400e',
                              fontSize: '13px',
                              fontWeight: 500
                            }}
                          >
                            🔒 Maximum limit of {inviteData.maxGuests} guest(s) reached for this booking link.
                          </div>
                        ) : (
                          <button
                            className="btn btn-add-person-custom w-100 d-flex align-items-center justify-content-center gap-2"
                            onClick={addPersonToList}
                            type="button"
                          >
                            <Plus size={18} />
                            Add Co-Traveller / Additional Guest{' '}
                            {inviteData?.maxGuests ? `(${formData.persons.length}/${inviteData.maxGuests})` : ''}
                          </button>
                        )}
                      </Col>
                    </Row>

                    {/* Total Pay Card */}
                    <div className="total-payable-card">
                      <div className="d-flex align-items-center gap-3">
                        <span style={{ fontSize: '28px' }}>💳</span>
                        <div>
                          <div className="text-muted small fw-semibold" style={{ letterSpacing: '0.5px' }}>
                            TOTAL PAYABLE CHARGES
                          </div>
                          <div className="total-payable-amount">₹{totalPayble}</div>
                        </div>
                      </div>
                      <div className="text-muted small">
                        Calculated for <strong>{formData.persons.length}</strong> guest(s)
                      </div>
                    </div>

                    {/* Action Bar */}
                    <div className="d-flex align-items-center justify-content-between flex-wrap gap-3 mt-4 pt-3 border-top">
                      <button
                        type="button"
                        className="btn btn-outline-secondary px-4 py-2"
                        style={{ borderRadius: '10px', fontWeight: '500' }}
                        onClick={() => history(-1)}
                      >
                        ← Back to Step 1
                      </button>

                      {razorpayOrder ? (
                        <button
                          type="button"
                          className="btn-accommodation-next"
                          onClick={() => openRazorpay(razorpayOrder)}
                        >
                          Pay Now Again
                        </button>
                      ) : (
                        <button
                          className="btn-accommodation-next"
                          type="submit"
                          disabled={click === true || isLoading}
                        >
                          {isLoading ? (
                            <>
                              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              Processing...
                            </>
                          ) : (
                            <>
                              Complete Booking & Confirm ➔
                            </>
                          )}
                        </button>
                      )}
                    </div>
                  </Form>
                </Col>
              </Row>
            </CardBody>
          </Card>
          )}
        </Col>
        {/* </div> */}
      </div>
    </div>
  );
};

export default AccommodationFormStepTwo;
